import { ROUTES } from 'parameters/index'
import { TrustpilotWidget } from 'components/vendor/TrustpilotWidget'
import { colors } from 'parameters'
import { TrustedSite } from 'components/content/trust/TrustedSite'
import { BlockComponent } from 'lib'
import { Popover } from 'components/elements/Popover'
import Image from 'next/legacy/image'
import { Divider, Link, Text, View } from 'reshaped/bundle'

export const ApplicationFooter: BlockComponent = () => (
	<View gap={4} paddingBlock={{ s: 4, m: 8 }}>
		<View gap={4} direction={{ s: 'column', m: 'row' }} attributes={{ style: { justifyContent: 'space-between' } }}>
			<Popover>
				<Popover.Trigger>
					<Text variant="body-1">
						This service is free and will <strong style={{ color: colors.orange1 }}>NOT</strong> affect your credit
						score
					</Text>
				</Popover.Trigger>
				<Popover.Content>
					A soft credit report is pulled in accordance with the customer’s written authorization on our site. After
					reviewing the offer, if a consumer chooses to apply for credit, lending partners or platforms may require a
					hard pull for processing on their website.
				</Popover.Content>
			</Popover>
			<View>
				<TrustpilotWidget widget={'microStar'} />
			</View>
		</View>
		<Divider />
		<Text variant="body-3" color="neutral-faded">
			<View gap={4}>
				<View.Item grow>
					<View direction="row" gap={4} justify="center">
						<Link attributes={{ rel: 'noreferrer', target: '_blank' }} color="inherit" href={ROUTES.PRIVACY_POLICY}>
							Privacy Policy
						</Link>
						<Link attributes={{ rel: 'noreferrer', target: '_blank' }} color="inherit" href={ROUTES.TERMS}>
							Terms of Service
						</Link>
						<Link attributes={{ rel: 'noreferrer', target: '_blank' }} color="inherit" href={ROUTES.DONOTSELL}>
							Do Not Sell/Share My Personal Information
						</Link>
						<Link
							attributes={{ rel: 'noopener noreferrer nofollow', target: '_blank' }}
							color="inherit"
							href={ROUTES.GLBA}
						>
							GLBA
						</Link>
						<Link attributes={{ rel: 'noreferrer', target: '_blank' }} color="inherit" href={ROUTES.DISCLOSURE}>
							Disclosures
						</Link>
						<Link
							attributes={{ rel: 'noopener noreferrer nofollow', target: '_blank' }}
							color="inherit"
							href="https://engine.tech/"
						>
							Powered by Engine by MoneyLion
						</Link>
					</View>
				</View.Item>
				<View direction="row" gap={4} justify="center">
					<Text align="center">
						ML Enterprise Inc. NMLS# 1475872 /{' '}
						<Link
							href="https://nmlsconsumeraccess.org/"
							attributes={{ rel: 'noopener noreferrer nofollow', target: '_blank' }}
							color="inherit"
						>
							NMLS Consumer Access
						</Link>
					</Text>
					<View direction="row" gap={3} align="center">
						<TrustedSite />
						<Image
							src="/images/equal-housing-opportunity.png"
							width={24}
							height={24}
							alt="Equal Housing Opportunity logo"
						/>
					</View>
				</View>
			</View>
		</Text>
	</View>
)
